import { createRef } from 'react'
//import { authService } from 'fbase'

import AppRouter from './AppRouter'

//함수형 컴포넌트(class 컴포넌트 아님)
function App() {
    const appRef = createRef()

    //createRef(또는 useRef): 자식 컴포넌트에 props 전달
    //useState: 함수형 컴포넌트에서도 상태를 관리
    //useEffect: 업데이트 될 때 (특정 props가 바뀔 때) 특정 작업을 처리

    return (
        <div ref={appRef}>
            <AppRouter ref={appRef} />
        </div>
    )
}

export default App
